import { KFButton } from '@kf/ic2fx';
import React, { FC } from 'react';
import { ReactComponent as OfferCheckIcon } from 'assets/OfferCheckIcon.svg';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';
import { Skeleton } from '@mui/material';
import { colors } from 'styles/colors';
import { useTranslation } from 'react-i18next';

interface IOfferAndRejectButtons {
  offer?: () => void;
  reject?: () => void;
  loading?: boolean;
}

const ButtonSkeleton = ({ shimmerCount = 2 }) => {
  return (
    <>
      {[...Array(shimmerCount)]?.map((_, i) => {
        return (
          <Skeleton
            key={i}
            variant='rectangular'
            width={i ? '11.6rem' : '9.6rem'}
            height='2.5rem'
            sx={{
              bgcolor: (theme) => theme.palette.neutral?.main,
            }}
          />
        );
      })}
    </>
  );
};

const OfferAndRejectButtons: FC<IOfferAndRejectButtons> = ({
  loading,
  offer,
  reject,
}) => {
  const { t: translate } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        columnGap: '0.8333rem',
        margin: '10px 0',
      }}
    >
      {loading ? (
        <Box id='loader' data-testid='loader'>
          <ButtonSkeleton />
        </Box>
      ) : (
        <>
          <KFButton
            id='extendOffferBtn'
            data-testid='extendOffferBtn'
            color='quaternary'
            icon={<OfferCheckIcon />}
            onClick={offer}
            sx={{
              padding: '0.625rem 1rem',
            }}
          >
            {translate('extendOffer')}
          </KFButton>
          <KFButton
            id='rejectCandidateBtn'
            data-testid='rejectCandidateBtn'
            color='dangerTertiary'
            icon={<CloseIcon sx={{ fontSize: '1rem !important' }} />}
            onClick={reject}
            sx={{
              color: `${colors.tertiary.cadimiumRed} !important`,
              padding: '0.625rem 1.25rem',
              '&:hover, &:focus': {
                color: `white !important`,
              },
            }}
          >
            {translate('rejectCandidate')}
          </KFButton>
        </>
      )}
    </Box>
  );
};

export default OfferAndRejectButtons;
